import { useEffect, useState } from 'react';
import { Loader } from '../../../component/loader';
import { DeleteModal } from '../../../component/modal/deleteModal';
import {
  useDeleteLifestyleCategoryMutation,
  useGetAllLifestyleCategoriesQuery
} from '../../../store/lifeStyle/api';
import { ILifeStyle } from '../../../store/lifeStyle/interface';
import {
  useDeleteStoreCategoryMutation,
  useGetCategoriesQuery
} from '../../../store/shopping/api';
import { IStoreCategory } from '../../../store/shopping/interface';
import { showErrorToast, showSuccessToast } from '../../../utils/toast';
import { CategoryListCard } from '../component/categoryListTable';
import { AddCategory } from '../modal/addCategory';
import { EditCategory } from '../modal/editCategory';
import {
  AddStoreBtn,
  CategoryButton,
  CategoryButtonSet,
  Container,
  Header,
  ListContainer,
  Title
} from './styles';

export const AllCategories = () => {
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [editCategoryModal, setEditCategoryModal] = useState(false);
  const [categoryId, setCategoryId] = useState('');
  const [categoryDetails, setCategoryDetails] = useState<
    ILifeStyle | IStoreCategory
  >();
  const [currentTab, setCurrentTab] = useState('Shopping');
  const {
    data: allShoppingCategories,
    isLoading: isShoppingCategoryListLoading
  } = useGetCategoriesQuery();
  const [deleteShoppingCategory, { isLoading: isStoreCategoryDeleting }] =
    useDeleteStoreCategoryMutation();
  const [deleteLifestyleCategory, { isLoading: isLifestyleCategoryDeleting }] =
    useDeleteLifestyleCategoryMutation();
  const [deleteCategoryModal, setDeleteCategoryModal] = useState(false);
  const { data: allLifestyleCategories } = useGetAllLifestyleCategoriesQuery();
  const [tableView, setTableView] = useState<ILifeStyle[] | IStoreCategory[]>(
    []
  );
  const handleAddCategory = () => {
    setAddCategoryModal(true);
  };
  const handleDeleteClick = (itemId: string) => {
    setDeleteCategoryModal(true);
    setCategoryId(itemId);
  };
  const handleEditClick = (item: ILifeStyle | IStoreCategory) => {
    setEditCategoryModal(true);
    setCategoryDetails(item);
  };
  const categoryTypes = [
    // { title: 'Lifestyle' },
    { title: 'Shopping' }
  ];
  const handleCategoryType = (categoryTitle: string) => {
    setCurrentTab(categoryTitle);
  };
  useEffect(() => {
    if (currentTab === 'Lifestyle') {
      setTableView(allLifestyleCategories?.data?.fetchedData ?? []);
    } else if (currentTab === 'Shopping') {
      setTableView(allShoppingCategories?.data ?? []);
    }
  }, [currentTab, allLifestyleCategories, allShoppingCategories]);

  const handleDeleteCategory = () => {
    if (currentTab === 'Lifestyle') {
      deleteLifestyleCategory(categoryId)
        .unwrap()
        .then((result) => {
          showSuccessToast(result.message);
          setDeleteCategoryModal(false);
        })
        .catch((error) => {
          showErrorToast(error.message);
        });
    } else if (currentTab === 'Shopping') {
      deleteShoppingCategory(categoryId)
        .unwrap()
        .then((result) => {
          showSuccessToast(result.message);
          setDeleteCategoryModal(false);
        })
        .catch((error) => {
          showErrorToast(error.message);
        });
    }
  };

  return (
    <Container>
      {isShoppingCategoryListLoading && <Loader />}
      {addCategoryModal && (
        <AddCategory setShow={setAddCategoryModal} currentTab={currentTab} />
      )}
      {editCategoryModal && (
        <EditCategory
          currentTab={currentTab}
          categoryDetails={categoryDetails}
          setShow={setEditCategoryModal}
        />
      )}
      {deleteCategoryModal && (
        <DeleteModal
          cancelBtnClick={() => setDeleteCategoryModal(false)}
          deleteBtnClick={handleDeleteCategory}
          isLoading={isStoreCategoryDeleting || isLifestyleCategoryDeleting}
          deleteText="Are you sure you want to delete this category, this action can’t be undone?"
          deleteTitle="Delete category"
        />
      )}
      <Header>
        <Title>All Categories</Title>
        <AddStoreBtn onClick={() => handleAddCategory()}>
          Add Categories
        </AddStoreBtn>
      </Header>
      <CategoryButtonSet>
        {categoryTypes.map((categoryType, index) => (
          <CategoryButton
            key={index}
            isActive={categoryType.title === currentTab}
            onClick={() => handleCategoryType(categoryType.title)}
          >
            {categoryType.title}
          </CategoryButton>
        ))}
      </CategoryButtonSet>
      <ListContainer>
        {tableView?.map((item, index) => (
          <CategoryListCard
            categoryItems={item}
            currentTab={currentTab}
            key={index.toString()}
            handleEditClick={() => handleEditClick(item)}
            handleDeleteClick={() => handleDeleteClick(item._id)}
          />
        ))}
      </ListContainer>
    </Container>
  );
};
